import { getInstance } from './instance';

export interface DraftSummary {
  draftId: string;
  draftName: string;
  bookTitle?: string;
  thumbnail?: string;
  createdAt?: string;
  coverReady: boolean;
  coverPdfUrl?: string;
  coverGeneratedAt?: string;
  manuscriptReady: boolean;
  manuscriptPdfUrl?: string;
}

export interface GenerateCoverOptions {
  include_spine: boolean;
  format: 'pdf';
  force_regeneration: boolean;
}

export interface GenerateCoverResponse {
  status: 'processing' | 'completed';
  download_url?: string;
  expires_at?: string;
}

export interface AssetStatus {
  status: 'processing' | 'completed' | 'failed';
  cover_pdf_url?: string;
  cover_generated_at?: string;
  manuscript_pdf_url?: string;
  updated_at: string;
}

const withOperator = (operatorEmail: string) => ({
  headers: { 'X-Admin-Identity': operatorEmail },
});

export const listDraftsByEmail = async (
  email: string,
  operatorEmail: string,
): Promise<DraftSummary[]> => {
  const response = await getInstance().get<DraftSummary[]>('assets/drafts', {
    params: { email },
    ...withOperator(operatorEmail),
  });
  return response.data;
};

export const generateCover = async (
  draftId: string,
  options: GenerateCoverOptions,
  operatorEmail: string,
): Promise<GenerateCoverResponse> => {
  const response = await getInstance().post<GenerateCoverResponse>(
    'assets/generate-cover',
    { draft_id: draftId, options },
    withOperator(operatorEmail),
  );
  return response.data;
};

export const getAssetStatus = async (
  draftId: string,
  operatorEmail: string,
): Promise<AssetStatus> => {
  const response = await getInstance().get<AssetStatus>(
    `assets/status/${draftId}`,
    withOperator(operatorEmail),
  );
  return response.data;
};
